document.addEventListener("DOMContentLoaded", function () {
  const infoIcons = document.querySelectorAll(".product-specs-info-icon");
  const contentDisplay = document.getElementById("specification-content-display");
  const overlay = document.querySelector(".help-overlay");
  const closeButton = document.querySelector(".close-button");
  const body = document.body;

  infoIcons.forEach((icon) => {
    icon.addEventListener("click", () => {
      const content = icon.getAttribute("data-spec-content");
      if (content) {
        contentDisplay.innerHTML = decodeHTML(content); // Set content inside the display div
        overlay.style.display = "block"; // Show overlay
        body.classList.add("help-active"); // Add 'help-active' class
      }
    });
  });

  closeButton.addEventListener("click", () => {
    clearContent();
  });

  overlay.addEventListener("click", () => {
    clearContent();
  });

  function clearContent() {
    contentDisplay.innerHTML = ""; // Clear the content
    overlay.style.display = "none"; // Hide overlay
    body.classList.remove("help-active"); // Remove 'help-active' class
  }

  function decodeHTML(html) {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea.value;
  }
});